import { createContext, useContext, type ReactNode } from 'react';

import { fetchLibraryPostsGateway } from '../api/fetchLibraryPostsGateway';
import type { LibraryPostsGateway } from '../ports/libraryPostsGateway';

/**
 * Which backend the library's hooks talk to. It defaults to the real one, so
 * the app mounts no provider; a test mounts one holding an in-memory gateway.
 */
const LibraryPostsGatewayContext = createContext<LibraryPostsGateway>(fetchLibraryPostsGateway);

export function LibraryPostsGatewayProvider({
  gateway,
  children,
}: {
  gateway: LibraryPostsGateway;
  children: ReactNode;
}) {
  return (
    <LibraryPostsGatewayContext.Provider value={gateway}>
      {children}
    </LibraryPostsGatewayContext.Provider>
  );
}

export function useLibraryPostsGateway() {
  return useContext(LibraryPostsGatewayContext);
}
